<button type="button" class="btn btn-inverse shadow-sm py-1" (click)="toggle()">
  @if (expand) {
    <i class="fa fa-angle-double-up" ></i>
  }
  @if (!expand) {
    <i class="fa fa-angle-double-down" ></i>
  }
</button>
